import { DivWithTooltip } from "Components/withPopover";
import includes from "lodash/includes";
import isNumber from "lodash/isNumber";
import styled from "styled-components";
export const SIZES = {
    BTN_SIZE: 28,
    BTN_GROUP_HEIGHT: 22
};
export default {
    ActionsMiniPanel: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["hasRightSideButton", "panelHeight"], prop)
    })
        .attrs({
        className: "border-bottom-gray-100"
    }) `
    height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
    display: grid;
    grid-template-columns: ${({ hasRightSideButton }) => hasRightSideButton ? "1fr auto auto" : "1fr auto"};
    align-items: center;
    > * {
      height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
    }
  `,
    DivWithTooltip: styled(DivWithTooltip) `
    width: ${SIZES.BTN_GROUP_HEIGHT}px;
    height: ${SIZES.BTN_GROUP_HEIGHT}px;
    right: 0.25em;
    top: 50%;
    transform: translateY(-50%);

    > div {
      display: grid;
      align-content: center;
      justify-content: center;
      width: 1.25em;
      height: 1.25em;
      font-size: 0.85em;
      font-weight: 700;
      border-radius: 50%;
      border: 1px solid ${({ theme }) => theme["brand-danger-500"]};
      color: ${({ theme }) => theme["brand-danger-500"]};
    }
  `,
    BtnContainer: styled.div `
    padding: 8px 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  `
};
